import { memo } from "react";

import { Stack } from "components/icons/generated";
import Icon from "ds/components/Icon";

import { type RenderGroupRowCellProps } from ".";
import IacManagementTableText from "../components/Text";
import { IAC_MANAGEMENTS_TABLE_COLUMNS } from "../types";
import useGroupNameActions from "./useGroupNameActions";
import IacManagementGroupCell from "../../components/Table/Row/Group/Cell";

const IacManagementTableGroupRowCellName = memo((props: RenderGroupRowCellProps) => {
  const { row } = props;

  const isStackRow = row.__typename === "ManagedEntitiesGroupedByStacks";

  const name = isStackRow ? row.stackName : row.id;
  const cellName = name || row.id || "[empty name]";

  const actions = useGroupNameActions(row.__typename, name);

  return (
    <IacManagementGroupCell {...props} actions={actions} role="rowheader">
      {isStackRow && <Icon src={Stack} noShrink />}
      <IacManagementTableText columnId={IAC_MANAGEMENTS_TABLE_COLUMNS.NAME}>
        {cellName}
      </IacManagementTableText>
    </IacManagementGroupCell>
  );
});

IacManagementTableGroupRowCellName.displayName = "IacManagementTableGroupRowCellName";

export default IacManagementTableGroupRowCellName;
